import React from 'react'
import { t } from 'ttag'
import { connect } from 'react-redux'
import {
  getRespondent,
  getLanguage,
  getPersonality,
  getGMA,
} from 'ducks/respondent'
import { toQuiz, toPersonalityQuiz } from 'ducks/router'
import * as R from 'ramda'
import { ProcessingSpeed } from 'components/modals/TestsReportModal/tabs/ProcessingSpeed/ProcessingSpeed'
import styles from './AbilityResults.module.scss'
import { BoldButton } from 'components/shared/BoldButton/BoldButton'
import PlayIcon from 'assets/icons/play.svg'
import BackIcon from 'assets/icons/back-arrow.svg'
import BackIconWhite from 'assets/icons/back-arrow-white.svg'
import { MailHint } from 'components/quiz/Quiz/Quiz'

const AbilityResults = ({
  name,
  id: uuid,
  scores,
  toQuiz,
  stats,
  language,
  toPersonality,
  status,
}) => {
  const isPersonalityCompleted = status === 'completed'
  const response = [{ name, scores, stats, id: uuid }]

  return (
    <div className={styles.abilityResults}>
      <div className={styles.title}>{t`Ability test results`}</div>
      <ProcessingSpeed
        factor={'GMA'}
        key={'GMA'}
        language={language}
        scores={scores}
        response={response}
        candidates={response}
        stats={stats.gma}
        isCandidate
        isGreyBackground
        single
      />
      <div className={styles.bottomBar}>
        <div className={styles.buttons}>
          <BoldButton
            label={t`Back to intro page`}
            icon={isPersonalityCompleted ? BackIconWhite : BackIcon}
            isIconFirst
            isPrimary={isPersonalityCompleted}
            onClick={() => toQuiz(uuid)}
          />
          {!isPersonalityCompleted ? (
            <BoldButton
              label={t`Go to personality test`}
              icon={PlayIcon}
              isIconFirst
              onClick={() => toPersonality(uuid)}
            />
          ) : null}
        </div>
        <MailHint />
      </div>
    </div>
  )
}

export default connect(
  R.converge(R.mergeRight, [
    getGMA,
    getRespondent,
    getLanguage,
    getPersonality,
  ]),
  dispatch => ({
    toQuiz: uuid => dispatch(toQuiz({ uuid })),
    toPersonality: uuid => dispatch(toPersonalityQuiz({ uuid })),
  }),
)(AbilityResults)
